export default __webpack_public_path__ + "static/media/beefy.3c8ba2f1.svg";